import { parseStreetAddress } from 'PatientTravel/utils'
import {
    SET_TRANSPORT_TYPE_OPTIONS,
    SET_SPECIAL_NEED_OPTIONS,
    SET_SPECIAL_NEEDS,
    SET_TRANSPORT_TYPES,
    SET_BOOKING,
    SET_CLIENT,
    SET_EDIT_CLIENT_DETAILS,
    SET_EDIT_CLINIC_DETAILS,
    SET_SECTION_OPTIONS,
    SET_MUNICIPALITY_OPTIONS,
    SET_PROFESSION_OPTIONS,
    SET_OFFICE,
    SET_PREFERENCES, SET_TREATMENTSITE_LOADER,
} from 'PatientTravel/store/mutation-types'
import backendService from 'PatientTravel/services/backendService'

export default {
    state: {
        transportTypes: [],
        transportTypeOptions: [],  // a filtered version of transportTypes
        specialNeeds: [],
        specialNeedOptions: [],  // a filtered version of specialNeeds
        professionOptions: [],
        sectionOptions: [],
        municipalityOptions: [],
        booking: {},
        client: {},
        office: {},
        preferences: {},
        loadingTreatmentSite: false,
    },
    mutations: {
        [SET_TRANSPORT_TYPES](state, payload) {
            state.transportTypes = payload
        },
        [SET_TRANSPORT_TYPE_OPTIONS](state, payload) {
            state.transportTypeOptions = payload
        },
        [SET_SPECIAL_NEEDS](state, payload) {
            state.specialNeeds = payload
        },
        [SET_SPECIAL_NEED_OPTIONS](state, payload) {
            state.specialNeedOptions = payload
        },
        [SET_PROFESSION_OPTIONS](state, payload) {
            state.professionOptions = payload
        },
        [SET_SECTION_OPTIONS](state, payload) {
            state.sectionOptions = payload
        },
        [SET_MUNICIPALITY_OPTIONS](state, payload) {
            state.municipalityOptions = payload
        },
        [SET_BOOKING](state, payload) {
            state.booking = payload
        },
        [SET_CLIENT](state, payload) {
            const parsedAddress = parseStreetAddress(payload?.address)
            const address = {
                ...parsedAddress,
                postcode: payload.zip,
                city: payload.city,
            }
            state.client = { ...payload, parsedAddress: { ...address }, }
        },
        [SET_OFFICE](state, payload) {
            state.office = payload
        },
        [SET_PREFERENCES](state, payload) {
            state.preferences = payload
        },
        [SET_TREATMENTSITE_LOADER](state, payload) {
            state.loadingTreatmentSite = payload
        },
    },
    actions: {
        async fetchTypeOptions({ commit }) {
            return backendService.fetchTypeOptions()
                .then(({ data }) => {
                    commit(SET_TRANSPORT_TYPES, data['transportTypes'])
                    commit(SET_SPECIAL_NEEDS, data['specialNeeds'])
                    commit(SET_TRANSPORT_TYPE_OPTIONS, data['transportTypes'])
                    commit(SET_SPECIAL_NEED_OPTIONS, data['specialNeeds'])
                })
        },
        async fetchTreatmentSiteFilters({ commit }) {
            return backendService.fetchTreatmentSiteFilters()
                .then(({ data }) => {
                    commit(SET_PROFESSION_OPTIONS, data['professions'])
                    commit(SET_SECTION_OPTIONS, data['sections'])
                    commit(SET_MUNICIPALITY_OPTIONS, data['municipalities'])
                })
        },
        setBooking({ commit }, payload) {
            commit(SET_BOOKING, payload)
        },
        setClient({ commit }, payload) {
            commit(SET_CLIENT, payload)
        },
        setEditClientDetails({ commit }, payload) {
            commit(SET_EDIT_CLIENT_DETAILS, payload)
        },
        setEditClinicDetails({ commit }, payload) {
            commit(SET_EDIT_CLINIC_DETAILS, payload)
        },
        async fetchOffice({ commit, dispatch }, postcode) {
            return await backendService.fetchOffice(postcode)
                .then(({ data }) => {
                    commit(SET_OFFICE, data)
                    dispatch('filterTypeOptions')
                })
        },
        filterTypeOptions({ state, commit }) {
            const availableSpecialNeeds = new Set(
                state.office?.specialNeeds || []
            )
            const availableTransportTypes = new Set(
                state.office?.transportTypes || []
            )

            const filteredSpecialNeeds = state.specialNeeds.filter(
                item => availableSpecialNeeds.has(item.codeRequisition)
            )
            const filteredTransportTypes = state.transportTypes.filter(
                item => availableTransportTypes.has(item.codeRequisition)
            )

            commit(SET_SPECIAL_NEED_OPTIONS, filteredSpecialNeeds)
            commit(SET_TRANSPORT_TYPE_OPTIONS, filteredTransportTypes)
        },
        async fetchPreferences({ commit }) {
            return backendService.getPreferences()
                .then(({ data }) => {
                    commit(SET_PREFERENCES, data)
                })
        },
    },
    getters: {
        transportTypeOptions: state => state.transportTypeOptions,
        specialNeedOptions: state => state.specialNeedOptions,
        professionOptions: state => state.professionOptions,
        sectionOptions: state => state.sectionOptions,
        municipalityOptions: state => state.municipalityOptions,
        booking: state => state.booking,
        client: state => state.client,
        office: state => state.office,
        preferences: state => state.preferences,
        loadingTreatmentSite: state => state.loadingTreatmentSite,
    }
}
